<template lang="pug">
include ../pug/svg
section#account
	nav.navbar.sticky
		div
			ul
				li(v-if="hasFeature('account','settings')")
					AppLink(:to="{name:'ManageAccountSettings'}") Settings
				li(v-if="hasFeature('account','profile')")
					AppLink(:to="{name:'ManageAccountProfile'}") Profile
				li(v-if="assignmentAccess")
					AppLink(:to="{name:'ManageAccountUserAssignment', params:{userId:authUser.id}}") Assignment
					
			button.but.pri.spinner(:class="{spin:saving}" type="button" :disabled="saving||!canSave" @click="saveAccount") Save
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
			button.but.pri.spinner(:class="{spin:resetting}" type="button" :disabled="resetting||!canCancel" @click="cancelAccount") Cancel
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
			
	ModalConfirm(:active="leaveTo" :useDrag="true" @cancel="leaveTo=null" @confirm="cancelAccount")
	//-pre updated: {{updated}}
	router-view(v-slot="{Component}")
		transition(name="section" mode="out-in" enter-active-class="hide" leave-active-class="hide" appear)
			component(:is="Component" :cancelled="cancelled" :saved="saved" @storeUpdated="storeUpdated($event)")
</template>

<script>
import UserService from '../services/UserService';
import ModalConfirm from '../components/ModalConfirm';

export default {
	name: 'ManageAccount',
	components: {
		ModalConfirm,
	},
	data() {
		return {
			updated: {
				profile: null,
				settings: null,
			},
			canSave: false,
			canCancel: false,
			cancelled: false,
			saving: false,
			resetting: false,
			saved: false,
			leaveTo: null,
		}
	},
	beforeRouteLeave (to, from, next) {
		// unsaved changes
		if (this.canSave && !this.leaveTo) {
			this.leaveTo = to;
			this.$store.dispatch('gui/setTintState', true);
			next(false);
			
		} else {
			next();			
		}
	},
	computed: {
		org() {
			return this.$store.state.gui.organisation;
		},
		authUser() {
			return this.$store.state.auth.user;
		},
		assignmentAccess() {
			return (this.org.assignmentIndividual && this.authUser.userOrganisations[0].role.slug === 'mentor');
		},
	},
	methods: {
		hasFeature(feature, subfeature) {
			return this.$store.getters['gui/hasFeature'](feature, subfeature);
		},
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		storeUpdated({screen, valid}) {
			if (!screen) {
				// if not present, trigered from ManagePeopleUserAssignment
				screen = 'assignment';
			}
			
			// log screen updated for efficient save
			this.updated[screen] = valid;
			
			let validSet = null;
			
			for(let screen in this.updated) {
				if (this.updated[screen] === false) {
					validSet = false;
					
				} else if (this.updated[screen] === true && validSet !== false) {
					validSet = true;
				}
			}
			
			// enable save button
			this.canSave = validSet ? true : false;
			this.canCancel = true;
		},
		async cancelAccount() {
			this.cancelled = true;
			this.canSave = false;
			this.canCancel = false;
			this.resetting = true;
			
			const delay = this.$store.getters['gui/delay'];			
			
			// reset auth user from db
			await this.$store.dispatch('auth/status');
			
			await delay;
			
			// disable save until changes
			this.resetFlags();
		},
		async saveAccount() {
			try {
				this.saving = true;
				const delay = this.$store.getters['gui/delay'];
				
				if (this.updated.profile || this.updated.settings || this.updated.assignment) {
					// copy store to local var for cleanse
					let storeUser = this.$store.state.auth.user;
					const user = {...storeUser};
					
					user.zoomUserEmail = user.userOrganisations[0].zoomUserEmail;
					
					// assigned users
					const assignments = this.$store.state.users.users.filter(u => u.userOrganisations[0].userOrganisationId === user.userOrganisations[0].id).map(u => u.userOrganisations[0].id);
					user.assignments = assignments;
					
					delete user.userOrganisations;
					delete user.userId;
					
					// save user to db
					const {data} = await UserService.updateUser(user);
					
					// update profileUrl in store
					this.$store.dispatch('auth/setProfileUrl', data.profileUrl);
					
					this.saved = true;
				}
				
				await delay;
				
				this.resetFlags();
				
			} catch(err) {
				// handle error
				console.log('saveAccount()>err:', err);
//				actions.setFieldError('name', err.response.data.message);
			}
		},
		resetFlags() {
			// reset
			this.updated.profile = null;
			this.updated.settings = null;
			this.canSave = false;
			this.canCancel = false;
			this.resetting = false;
			this.saving = false;
			this.saved = false;
		},
	},
}
</script>

<style lang="scss">
#account {
	.navbar.sticky {
		position: sticky;
		top: 70px;
	}
}
</style>
